import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { TransportManagementFilterName } from '../constants/transport-management.constant';
import {
  TransportManagementFiltersLoad,
  TransportManagementFiltersInitialState,
  TransportManagementFilterUpdate,
} from './transport-management-filters.actions';
import { TransportManagementFiltersState } from './transport-management-filters.state';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TransportManagementFiltersFacade implements LoadDataFacade, SetInitialStateFacade {
  items$: Observable<TransportManagementFilterName[]> = this.store.select(TransportManagementFiltersState.getItems);
  loaded$: Observable<boolean> = this.store.select(TransportManagementFiltersState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new TransportManagementFiltersLoad());
  }

  updateFilters(filters: TransportManagementFilterName[]): void {
    this.store.dispatch(new TransportManagementFilterUpdate(filters));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportManagementFiltersInitialState());
  }
}
